/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNotificationSettingsSyncValueRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/notification_settings_sync_value.pb'
import {GetNotificationSettingsSyncValueResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/notification_settings_sync_value.pb'


export const getNotificationSettingsSyncValue = (request: GetNotificationSettingsSyncValueRequest, options?: CashRequestOptions) => post<GetNotificationSettingsSyncValueRequest, GetNotificationSettingsSyncValueResponse>("/cash-app/notification-settings/api/web/notification-settings-sync-value", request, {...options, rejectOnError: true })